import { planLabel, type OrgPlan, type OrgStatus } from "@currencycore/shared";
import { compact } from "./Charts.tsx";

const PLAN_VARIANT: Record<OrgPlan, string> = {
  free: "badge-neutral",
  starter: "badge-accent",
  growth: "badge-info",
  growth_plus: "badge-info",
  business: "badge-info",
  enterprise: "badge-violet",
  custom: "badge-warn",
};

export function PlanBadge({ plan, label }: { plan: OrgPlan; label?: string | null }) {
  return <span className={`badge ${PLAN_VARIANT[plan]}`}>{label?.trim() || planLabel(plan)}</span>;
}

const STATUS_VARIANT: Record<OrgStatus, string> = {
  active: "badge-ok",
  past_due: "badge-warn",
  canceled: "badge-danger",
};

export function StatusBadge({ status }: { status: OrgStatus }) {
  return <span className={`badge ${STATUS_VARIANT[status]}`}>{status.replace("_", " ")}</span>;
}

/** Inline usage meter with used / limit caption. */
export function Meter({ used, limit }: { used: number; limit: number | null }) {
  const pct = limit && limit > 0 ? Math.min(100, (used / limit) * 100) : limit === null ? 4 : 0;
  const cls = limit && pct >= 90 ? "is-danger" : limit && pct >= 70 ? "is-warn" : "";
  return (
    <div className="usage-cell">
      <div className="umeter">
        <span className={`umeter-fill ${cls}`} style={{ width: `${Math.max(pct, used > 0 ? 3 : 0)}%` }} />
      </div>
      <span className="umeter-cap tnum muted">
        {compact(used)} / {limit === null ? "∞" : compact(limit)}
      </span>
    </div>
  );
}
